// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"u4-z"};